import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addStarknetInjectedWalletsExtension } from '../injected/addStarknetInjectedWalletsExtension';

/**
 * Adds the Starknet extension to the Dynamic client.
 *
 * This is a convenience function that adds support for a variety of Starknet wallets,
 * like Braavos, Ready and more.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */

export const addStarknetExtension = (client = getDefaultClient()): void => {
  addStarknetInjectedWalletsExtension(client);
};
